import * as React from 'react';
import { getThemeLoader } from './themes';
import LC from './context';
import { getRuntimeConfig } from 'lib/runtimeConfig';
import { handleImport } from 'lib/import';

export const DEFAULT_LABEL = 'dokka';

const whitelabelConfigLoaders = {
  dokka: () => handleImport(import('./dokka')),
  pegasus: () => handleImport(import('./pegasus')),
  alprime: () => handleImport(import('./alprime')),
  bdo: () => handleImport(import('./bdo')),
  profitian: () => handleImport(import('./profitian')),
  autodok: () => handleImport(import('./autodok')),
  made: () => handleImport(import('./made')),
  nextAge: () => handleImport(import('./nextAge')),
};

const getWhitelabelConfigLoader = (wlName) => whitelabelConfigLoaders[wlName] || whitelabelConfigLoaders[DEFAULT_LABEL];

class Labels extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      currentLabelName: null,
      styles: null,
      labelOptions: null,
    };
  }

  componentDidMount() {
    this.setLabel();
  }

  componentDidUpdate(prevProps, prevState) {
    const { currentLabelName, labelOptions } = this.state;

    this.setLabel();

    if (prevState.currentLabelName !== currentLabelName) {
      this.loadLabelConfig();
    }

    if (!Object.is(prevState.labelOptions, labelOptions)) {
      this.updateFavicon();
      this.updateTitle();
    }
  }

  setLabel = () => {
    const { currentLabelName } = this.state;
    const hostLabel = getRuntimeConfig().whitelabel.WL_NAME;
    if (currentLabelName !== hostLabel) {
      this.setState({ currentLabelName: hostLabel });
    }
  };

  updateFavicon = () => {
    const { labelOptions } = this.state;
    const links = document.getElementsByTagName('link');

    Array.from(links).forEach((link) => {
      const dataID = link.getAttribute('data-icon');
      const option = labelOptions[dataID];
      if (option) {
        link.setAttribute('href', option);
      }
    });
  };

  updateTitle = () => {
    const { labelOptions } = this.state;
    const titles = document.getElementsByTagName('title');
    Array.from(titles).forEach((title) => {
      const text = labelOptions.title;
      if (text) {
        // eslint-disable-next-line
        title.textContent = text;
      }
    });
  };

  loadLabelConfig = () => {
    const { currentLabelName } = this.state;
    if (currentLabelName) {
      getWhitelabelConfigLoader(currentLabelName)().then((module) => {
        const labelOptions = module.default;
        this.setState({ labelOptions });
        this.loadThemeStyle(labelOptions.theme);
      });
    }
  };

  loadThemeStyle = (theme) => {
    // TODO: deprecated, legacy theme configs - need delete after remove all styles from project
    getThemeLoader(theme)().then((module) => {
      const styles = module.default;
      this.setState({ styles });
    });
  };

  render() {
    const { children } = this.props;
    const { currentLabelName, labelOptions, styles } = this.state;
    return currentLabelName && labelOptions && styles ? (
      <LC.Provider value={{ label: currentLabelName, labelOptions: { ...labelOptions, styles } }}>
        {children}
      </LC.Provider>
    ) : null;
  }
}

export default Labels;
